module.exports = __webpack_public_path__ + "media/images/qualicert-428c09302deef8d9a92f4f17eb193216.png";